import React, { useState } from 'react';
import NMH_LOGO_horizonal from '../Assets/NMH_LOGO_horizonal.png';
import {  useNavigate } from "react-router-dom";
import axios from 'axios';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import './login.css';


const Login = () => {

  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const handleGoogleLoginSuccess = async (credentialResponse) => {
    try {
        axios.defaults.withCredentials = true;           
      
        const response = await axios.post(`${API_BASE_URL}/api/auth/google`, {
            token: credentialResponse.credential,
        });
        if (response.data.success) {
            setUserData(response.data.user);

            const homePageView = response.data.homePageView;
                if (homePageView === 'Admin') {
                    navigate('/Homepage', { state: { userData } });
                }
                 else if (homePageView === 'Editor') {
                    navigate('/Homepage', { state: { userData } });
                }
                else if (homePageView === 'User') {
                    navigate('/Homepage', { state: { userData } });
                }
        } else {
          logOut();
            console.log('Google login failed');
        }
    } catch (error) {
        logOut();
        console.log('Error verifying login token:', error);
    }
};

  const handleGoogleLoginSuccessTest = async (credentialResponse) => {
    try {
        axios.defaults.withCredentials = true;           
      
        const response = await axios.post(`${API_BASE_URL}/api/auth/googleTest`, {
            token: credentialResponse.credential,
        });
        if (response.data.success) {
            setUserData(response.data.user);

            const homePageView = response.data.homePageView;
                if (homePageView === 'Admin') {
                    navigate('/Homepage', { state: { userData } });
                }
                else if (homePageView === 'Editor') {
                    navigate('/Homepage', { state: { userData } });
                }
                else if (homePageView === 'user') {
                    navigate('/Homepage', { state: { userData } });
                }
        } else {
          logOut();
            console.log('Google login failed');
        }
    } catch (error) {
        logOut();
        console.log('Error verifying login token:', error);
    }
};

  const handleGoogleLoginSuccessTestUser = async (credentialResponse) => {
    try {
        axios.defaults.withCredentials = true;           
      
        const response = await axios.post(`${API_BASE_URL}/api/auth/googleTestUser`, {
            token: credentialResponse.credential,
        });
        if (response.data.success) {
            setUserData(response.data.user);

            const homePageView = response.data.homePageView;
                if (homePageView === 'Admin') {
                    navigate('/Homepage', { state: { userData } });
                }
                else if (homePageView === 'Editor') {
                    navigate('/Homepage', { state: { userData } });
                }
                else if (homePageView === 'User') {
                    navigate('/Homepage', { state: { userData } });
                }
        } else {
          logOut();
            console.log('Google login failed');
        }
    } catch (error) {
        logOut();
        console.log('Error verifying login token:', error);
    }
};

const logOut = async () => {
  try {
      await axios.post(`${API_BASE_URL}/api/auth/logout`, {}, { withCredentials: true });
      localStorage.clear();
      sessionStorage.clear();

    //   const oktaIframe = document.createElement('iframe');
    //   oktaIframe.src = `https://nmhschool.okta.com/login/signout`;
    //   oktaIframe.style.display = 'none';
    //   document.body.appendChild(oktaIframe);
      const googleLogoutWindow = window.open(`https://accounts.google.com/logout`, '_blank');

      setTimeout(() => {
          if (googleLogoutWindow) googleLogoutWindow.close(); 
        //   document.body.removeChild(oktaIframe); 
          navigate('/login'); 
      }, 3000);
  } catch (error) {
      console.error('Logout failed:', error.message);
  }
};

return (
     <>
     <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div>
              <div className="top-bar">
                  <h2>Opportunities Beyond Campus</h2>
              </div>
              <div className="login-form">
                  <img src={NMH_LOGO_horizonal} alt="NMH Logo" />
                  <h2 class="styled-heading"> Login</h2>

                 {/* <h3 class="styled-heading"> Admin</h3> */}
                  <div className="container">
                      <GoogleLogin
                          onSuccess={handleGoogleLoginSuccess}
                          onError={() => {
                              console.log("Login Failed");
                          }}
                          useOneTap
                          class="login-with-google-btn"
                      />
                  </div>
                    {/* <h3 class="styled-heading"> Editor</h3>

                  <div className="container">
                      <GoogleLogin
                          onSuccess={handleGoogleLoginSuccessTest}
                          onError={() => {
                              console.log("Login Failed");
                          }}
                          useOneTap
                          class="login-with-google-btn"
                      />
                  </div> */}
                  {/* <h3 class="styled-heading"> User</h3> */}
                   {/* <div className="container">
                      <GoogleLogin
                          onSuccess={handleGoogleLoginSuccessTestUser}
                          onError={() => {
                              console.log("Login Failed");
                          }}
                          useOneTap
                          class="login-with-google-btn"
                      />
                  </div> */}
              </div>
          </div>
      </GoogleOAuthProvider>
     </>
   
  );
};

export default Login;